import React from 'react';

export const CaretDownCircle = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="8" height="5" viewBox="0 0 8 5" fill="#21201F" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M7.75 0.5L4 4.25L0.25 0.5H7.75Z" fill="currentColor" />
    </svg>
  );
};
